<template>
  <nav>
    <v-row
      v-if="error"
      class="fill-height"
    >
      <v-col
        align-self="center"
        class="text-center"
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
      >
        <AlertMessages
          v-if="alertValue"
          class="mb-8 mx-auto"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-img
          src="../../assets/image3.png"
          width="100%"
          max-width="400px"
          class="mx-auto mb-10"
        />
        <div v-if="isLoading">
          <v-progress-circular indeterminate />
          <p class="body-1">
            {{ $t('confirmAccountLoading') }}
          </p>
        </div>
        <p class="text-h5 font-weight-bold">
          {{ errorMsgTitle }}
        </p>
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="body-1"
          v-html="errorMsg"
        />
        <v-btn
          v-if="expired"
          data-testid="resend-button"
          :loading="loading"
          color="accent"
          large
          class="rounded-xxl text-none mt-10 px-4"
          @click="resendConfirmationLink"
        >
          {{ $t('confirmAccountBtnResendRegistrationEmail') }}
        </v-btn>
        <v-btn
          v-else
          data-testid="redirect-button"
          color="accent"
          large
          class="rounded-xxl text-none mt-10 px-4"
          @click="redirectToLogin"
        >
          {{ $t('confirmAccountBtnRedirectToLogin') }}
        </v-btn>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import { verifyUser, resendEmail } from '../../api/userApi'
import moment from 'moment'
import i18n from '../../plugins/i18n'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            isLoading: false,
            loading: false,
            error: false,
            errorMsg: '',
            errorMsgTitle: '',
            buttonText: '',
            buttonLink: '',
            expired: false,
            token: '',
            alertType: '',
            alertMsg:'',
            alertValue:false
         }
    },
    async created() {
        this.isLoading = true 
        try {
            const response = await verifyUser(this.$route.query.verification_url, this.$route.query.signature)
            if(response.status == 200) {
                if (this.$route.query.referer) {
                    var referer = this.$route.query.referer
                    if (response.data.meta.code == 'userAlreadyVerified'){
                        this.$router.push({name: 'Login', query: {referer: referer}, params: {alreadyVerifiedEmail: true}})
                    } else {
                        this.$router.push({name: 'Login', query: {referer: referer}, params: {verifiedEmail: true}})
                    }
                } else {
                    if (response.data.meta.code == 'userAlreadyVerified'){
                        this.$router.push({name: 'Login', params: {alreadyVerifiedEmail: true}})
                    } else {
                        this.$router.push({name: 'Login', params: {verifiedEmail: true}})
                    }
                }
            }
        } catch (e) {
            this.error = true
            this.isLoading = false
            if(e.response){
                if(e.response.status == 403){
                    let verification_url = this.$route.query.verification_url
                    let expires = verification_url.split('expires=')[1]
                    moment(new Date(expires)).format('L')
                    if(moment().isAfter(moment(+(expires*1000)))){
                        this.token = e.response.data.errors[0].meta.access_token;
                        this.expired = true
                        this.errorMsgTitle = i18n.t('confirmAccountErrorExpiredTitle')
                        this.errorMsg = i18n.t('confirmAccountErrorExpiredText')
                    }else {
                        this.errorMsgTitle = i18n.t('confirmAccountErrorTitle')
                        this.errorMsg = i18n.t('confirmAccountErrorText')
                    }
                }else {
                    this.errorMsgTitle = i18n.t('confirmAccountErrorTitle')
                    this.errorMsg = i18n.t('confirmAccountErrorText')
                }
            }
        }
    },
    methods: {
        redirectToLogin(){
            if (this.$route.query.referer) {
                let referer = this.$route.query.referer
                this.$router.push({path: '/login', query: {referer: referer}})
            } else {
                this.$router.push({path: '/login'})
            }
        },
        async resendConfirmationLink(){
            this.loading = true
            try {
                const response = await resendEmail(this.token)
                 if(response.status == 200) {
                    this.verified = false
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('verificationLinkSent')
                    this.loading = false
                    this.alertValue = true
                }
            } catch (e){
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
                this.loading = false
                this.alertValue = true
            }
        }
    }
}
</script>